<template>
    <div v-if="loading">
        <div style="display: flex; justify-content: center;">
            <v-progress-circular indeterminate color="primary" size="64" width="2" />
        </div>
    </div>
    <div v-else-if="success">
        <h3>{{ $translate('You are now unsubscribed from newsletters') }}</h3>
    </div>
    <div v-else-if="success !== undefined">
        <h3>{{ $translate('An error occurred when attempting to unsubscribe') }}</h3>
    </div>
</template>

<script>
export default {
    name: 'zoezi-mailing-unsubscribe',
    data: () => ({
        loading: false,
        success: undefined
    }),
    mounted() {
        if (!this.$route.query.hash) {
            return;
        }
        this.loading = true;
        this.$api.post('/api/mailing/unsubscribe', null, {unsubscribeId: this.$route.query.hash}).then(result => {
            this.success = result.ok;
            this.loading = false;
        }).catch(() => {
            this.success = false;
            this.loading = false;
        });
    }
}
</script>
